import React from 'react';

import { createGlobalStyle, ThemeProvider as ThemeProviderSS } from 'styled-components';

import { defaultTheme } from './default-theme';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${(props) => props.theme.default.fontFamily};
    background-color: ${(props) => props.theme.default.backgroundColor};
    margin:0;
  }
`;

export const ThemeProvider = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <ThemeProviderSS theme={defaultTheme}>
    <GlobalStyle />
    {children}
  </ThemeProviderSS>
);

export const ThemeDecorator = (storyFn: () => JSX.Element): JSX.Element => (
  <ThemeProviderSS theme={defaultTheme}>
    <GlobalStyle />
    {storyFn()}
  </ThemeProviderSS>
);
